import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { IOuter } from '../../EmptyState.types';

import styles from './SiteFilesNewDnDSubtitle.scss';

export const SiteFilesNewDnDSubtitle: FC<IOuter> = () => (
  <span className={classNames({ [styles.subtitleNewBrandStyles]: window.isNewColorsBrandingEnabled })}>
    <FormattedMessage id="empty-state.folder-subtitle-new-dnd" />
  </span>
);
